import { TextField } from '@mui/material';

export const renderTextField = ({ input, meta, ...custom }) => <TextField {...input} {...custom} />;
